import { Component } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-payment-received',
  standalone: true,
  imports: [MatDialogModule],
  templateUrl: './payment-received.component.html',
  styleUrl: './payment-received.component.scss'
})
export class PaymentReceivedComponent {

}
